import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  arrayMove,
  arrayPush,
  arrayRemove,
  arraySwap,
  change,
  formValues,
} from 'redux-form'
import { Form, Grid, Segment, Table } from 'semantic-ui-react'
import ProductAccessoryRow from './ProductAccessoryRow'
import ProductBrowser from './ProductBrowser'

const mapStateToProps = (state, ownProps) => {
  const { products } = state.product
  const { pathLeaves } = state.categories
  return { products, pathLeaves }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      arrayPush,
      arrayRemove,
      arraySwap,
      change,
      arrayMove,
    },
    dispatch
  )
}

class ProductAccessories extends React.Component {
  state = {
    dragMarker: {},
  }

  addAccessory(accessory) {
    const { arrayPush, change, form } = this.props
    arrayPush(form, 'accessories', accessory)
    if (accessory.kind === 'category') {
      change(form, 'newAccessoryCategoryId', null)
    }
  }

  moveAccessory(oldIndex, newIndex) {
    const { form, arrayMove } = this.props // redux
    arrayMove(form, 'accessories', oldIndex, newIndex)
  }

  findAccessory(dragId) {
    const { accessories = [] } = this.props
    const item = accessories.find(
      (accessory) => dragId === `${accessory.kind}${accessory.id}`
    )
    return {
      item,
      index: accessories.indexOf(item),
    }
  }

  getAccessoryList() {
    const { dragMarker = {} } = this.state
    const { accessories = [] } = this.props //formValues
    const { form } = this.props //ownProps
    const { products, pathLeaves, arrayRemove } = this.props //redux
    const accessoriesWithData = accessories.map((accessory) => {
      let returnValue = {}
      if (accessory.kind === 'product') {
        returnValue = {
          ...accessory,
          product:
            products.find((product) => product.id === accessory.id) || {},
        }
      } else if (accessory.kind === 'category') {
        returnValue = {
          ...accessory,
          category:
            pathLeaves.find((category) => category.value === accessory.id) ||
            {},
        }
      }
      return returnValue
    })
    return accessoriesWithData.map((accessory, index) => (
      <ProductAccessoryRow
        {...{
          key: index,
          accessory: accessory,
          index: index,
          dragId: `${accessory.kind}${accessory.id}`,
          unlinkAccessory: (index) => arrayRemove(form, 'accessories', index),
          moveItem: (oldIndex, newIndex) =>
            this.moveAccessory(oldIndex, newIndex),
          findItem: (dragId) => this.findAccessory(dragId),
          setDragMarker: (dragMarker) => this.setState({ dragMarker }),
          dragMarker: dragMarker,
        }}
      />
    ))
  }

  render() {
    const dark = config.theme.dark
    const { products, pathLeaves } = this.props
    const { accessories = [] } = this.props
    const excludeProductIds = accessories
      .filter((accessory) => accessory.kind === 'product')
      .map((accessory) => accessory.id)
    const excludeCategoryIds = accessories
      .filter((accessory) => accessory.kind === 'category')
      .map((accessory) => accessory.id)
    const remainingPathLeaves = pathLeaves.filter(
      (categoryPath) => !excludeCategoryIds.includes(categoryPath.value)
    )
    return (
      <Grid className="ProductAccessories">
        <Grid.Row>
          <Grid.Column width={6}>
            <Form.Dropdown
              {...{
                name: 'newAccessoryCategoryId',
                options: remainingPathLeaves,
                value: undefined,
                onChange: (event, data) =>
                  this.addAccessory({ kind: 'category', id: data.value }),
                placeholder: I18n.t('global.select_category'),
                label: I18n.t('admin.product.accessories.add_category'),
                search: true,
                selection: true,
              }}
            />
            <ComponentHeader
              inline
              title={I18n.t('admin.product.accessories.linked_products')}
            />
            {/*
            <Button {...{
              content:       I18n.t('admin.product.accessories.add_category'),
              primary:       true,
              labelPosition: 'right',
              icon:          'plus',
              disabled:      !newAccessoryCategoryId,
              onClick:       () => {
                this.addAccessory({ kind: 'category', id: newAccessoryCategoryId })
              }
            }}
            />
*/}
            <Segment
              attached
              className={classNames(['payload', dark && 'inverted'])}>
              <Table
                sortable
                compact
                size="small"
                selectable
                basic="very"
                className="spaced cropped">
                <Table.Body children={this.getAccessoryList()} />
              </Table>
            </Segment>
          </Grid.Column>

          <Grid.Column width={6}>
            <ProductBrowser
              {...{
                selectable: 'left',
                form: 'accessory_browser',

                initialValues: {
                  filterActive: true,
                  filterInactive: false,
                  filterArchived: false,
                  filterProduct: true,
                  filterFamily: false,
                  filterFamilyMember: true,
                  filterText: '',
                  categoryFilter: -1,
                },
                displayOnly: 'accessories', // TODO: @andreas – product.kind or category node, e.g. /categories/accessories/ ?
                exclude: excludeProductIds,
                onSelect: (article_number) => {
                  const product = products.find(
                    (product) => product.article_number === article_number
                  )
                  if (product)
                    this.addAccessory({ kind: 'product', id: product.id })
                },
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

ProductAccessories = connect(mapStateToProps, mapDispatchToProps)(
  ProductAccessories
)
ProductAccessories = formValues('accessories', 'newAccessoryCategoryId')(
  ProductAccessories
)
export default ProductAccessories



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductAccessories.jsx